<template>
  <div class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"/>
          <h4 class="modal-title">Add field options from template</h4>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="row">
              <spinner v-if="loading"/>
              <div v-else class="form-group">
                <label class="control-label">Select template</label>
                <select v-model="selectedTemplate"
                        class="form-control">
                  <option v-for="template in templates"
                          :value="template">
                    {{ template.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn green" @click.prevent="confirmed()" data-dismiss="modal" :disabled="!selectedTemplate">Save</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  import Spinner from '@/components/Spinner';

  export default {
    components: {
      Spinner,
    },
    data() {
      return {
        selectedTemplate: null,
      }
    },
    computed: {
      ...mapGetters({
        loading: 'fieldTemplates/getLoading',
        templates: 'fieldTemplates/getFieldTemplates',
      })
    },
    methods: {
      confirmed() {
        this.$emit('confirmed', this.selectedTemplate);
      },
      ...mapActions({
        fetchTemplates: 'fieldTemplates/fetchFieldTemplates'
      })
    },
    mounted() {
      this.fetchTemplates();
    }
  }
</script>



// WEBPACK FOOTER //
// SelectFieldTemplateModal.vue?149815ab